import { useSelector } from 'react-redux';
import {
    freemiumHeavyFile,
    isControlFreemium,
    isHardFreemium,
    isSoftFreemium,
} from 'reactApp/appHelpers/featuresHelpers/features/freemium';
import { useHadFreemiumSubscription } from 'reactApp/hooks/useFreemium';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';

export const useShouldShowFreemiumHeavyFile = (): boolean => {
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const hadFreemium = useHadFreemiumSubscription();

    return freemiumHeavyFile && (isSoftFreemium || isHardFreemium || isControlFreemium) && !hadFreemium && !isPaidUser;
};
